import * as THREE from "three"
import { useEffect, useRef, useState  } from 'react'
import { useGLTF } from "@react-three/drei";
import { useFrame } from '@react-three/fiber';

var url = './3DModels/Happy1.glb';

function Model3DHappy({ children, ...props }){
  function SetMaterial(material) {
    if (material.map) material.map.anisotropy = 16;
    return material
  } 

  const actions = useRef()
  const group = useRef()
  const { nodes, animations, materials } = useGLTF(url)
  const [mixer] = useState(() => new THREE.AnimationMixer())
  console.log(animations)


  useEffect(() => {
    actions.current = { idle: mixer.clipAction(animations[0], group.current) }
    actions.current.idle.play()
    return () => animations.forEach((clip) => mixer.uncacheClip(clip))
  }, [mixer, animations])
  
  useFrame((state, delta) => {
    mixer?.update(delta)
})
    
  return(
    <group ref={group} {...props} dispose={null} scale={[200.0, 200.0, 200.0]} position={[0.0, -1.5, 0.0]} rotation={[0, 0, 0]}>
      <primitive object={nodes["mixamorigHips"]} />
      <skinnedMesh receiveShadow castShadow geometry={nodes["Girl_Set03_Top_geo"].children[0].geometry} skeleton={nodes["Girl_Set03_Top_geo"].children[0].skeleton} material={SetMaterial(materials.Girl_Set03)}> </skinnedMesh>
      <skinnedMesh receiveShadow castShadow geometry={nodes["Girl_Set03_Top_geo"].children[1].geometry} skeleton={nodes["Girl_Set03_Top_geo"].children[1].skeleton} material={materials.Girl_Body}></skinnedMesh>
      <skinnedMesh receiveShadow castShadow geometry={nodes["Girl_Set03_Top_geo"].children[2].geometry} skeleton={nodes["Girl_Set03_Top_geo"].children[2].skeleton} material={materials.Girl_Face}></skinnedMesh>
      <skinnedMesh receiveShadow castShadow geometry={nodes["Girl_Set03_Top_geo"].children[3].geometry} skeleton={nodes["Girl_Set03_Top_geo"].children[3].skeleton} material={materials.Girl_Set02_Hair}></skinnedMesh>
    </group>
  )
}

export default Model3DHappy;

useGLTF.preload(url)